import { SortOffersBy } from 'logic/api-models/sort-offer-by';
import { translate, translationKeys } from 'logic/translations/translations.service';

export const getValueTranslation = (sortOffersBy?: SortOffersBy) =>
  sortOffersBy ? translate(translationKeys.search.sortDropdown.options[sortOffersBy]) : '';
